import React, { PureComponent, Fragment } from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'
import moment from 'moment'

import { connect } from 'redaction'
import actions from 'redux/actions'
import { compose, constants, links, mixpanel } from 'common/helpers'
import injectGlobals from 'decorators/injectGlobals'

import Box from 'components/_new/layout/Box/Box'
import Image from 'components/_new/ui/Image/Image'
import Text from 'components/_new/typography/Text/Text'
import Link from 'components/_new/typography/Link/Link'
import UpchargePrice from 'components/UpchargePrice/UpchargePrice'

import messages from './messages'
import s from './Fragrance.scss'


class FragranceNotification extends PureComponent {

  static contextTypes = {
    close: PropTypes.func,
  }

  static propTypes = {
    item: PropTypes.object,
    isQueueItem: PropTypes.bool,
    placement: PropTypes.string,
    onClose: PropTypes.func,
    showForNonSubscribed: PropTypes.bool,
  }

  handleClick = (event) => {
    const { close } = this.context
    const { isQueueItem, onClose, placement } = this.props

    close()

    // Prevent default mixpanel event
    event.stopPropagation()

    mixpanel.track(constants.analyticsEvents.notificationClick, {
      template: 'perfumeItem',
      type: isQueueItem ? 'queue' : 'cart',
      placement,
    })

    if (isQueueItem) {
      actions.models.router.push(links.queue)
    }

    if (typeof onClose === 'function') {
      onClose()
    }
  }

  render() {
    const {
      item: { name, brand, img, image, url, upchargePrice, month, year },
      isQueueItem, showForNonSubscribed,
    } = this.props

    const itemImg    = img || image || url
    const itemName   = brand ? name : 'giftset'
    const itemBrand  = brand || name.replace(' giftset', '')
    const scheduledDate = month && year ? `${moment.monthsShort(month - 1)} ${year}` : null

    const addInfoClassName = cx({
      [s.addInfoCapitaliseFirstLetter]: showForNonSubscribed,
    })

    return (
      <div className={s.item} onClick={this.handleClick} data-testid={constants.testIds.common.topRightPopup}>
        <div className={s.preview}>
          {
            Boolean(upchargePrice) && (
              <UpchargePrice className={s.upchargePrice} price={upchargePrice} small />
            )
          }
          <Image fullWidth src={itemImg} h={100} x2 x3 />
        </div>
        {
          !showForNonSubscribed && (
            <Fragment>
              <div className={s.brand}>{itemBrand}</div>
              <div className={s.name}>{itemName}</div>
            </Fragment>
          )
        }
        {
          isQueueItem && scheduledDate && (
            <Text
              className={addInfoClassName}
              message={messages.addedToQueue}
              values={{ scheduledDate }}
              semibold
              size="14-24"
              color={showForNonSubscribed ? 'black' : 'brand'}
            />
          )
        }
        {
          !isQueueItem && (
            <Text
              className={addInfoClassName}
              message={messages.addedToCart}
              semibold
              size="14-24"
              color={showForNonSubscribed ? 'black' : 'brand'}
            />
          )
        }
        {
          showForNonSubscribed && (
            <Box mt="4">
              <Link color="brand">
                <Text size="14-24" inline message={messages.viewQueue} />
              </Link>
            </Box>
          )
        }
      </div>
    )
  }
}


export default compose(
  injectGlobals(({ getFeatureToggle }) => ({
    isQueuePageForNonSubscribedEnabled: getFeatureToggle(constants.features.queuePageForNonSubscribed),
  })),
  connect({
    showForNonSubscribed: (state, props) => {
      const { models: { subscription: { isNotSubscribed } } } = state
      const { isQueuePageForNonSubscribedEnabled } = props

      return isQueuePageForNonSubscribedEnabled && isNotSubscribed
    },
  }),
)(FragranceNotification)
